import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';
import * as Constants from 'src/constants';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-11-09'
        tag='Poshmark'
        title='Poshmark Seller Protection - How to Safely Sell on Poshmark'
      >
        <p>
          Unfortunately, along with the rising number of online shoppers becoming loyal users of these online
          marketplaces, opportunistic buyers are also rising, which puts many sellers in danger of being scammed. And
          while we have a clear idea of what being a victim of fraud is, there might still be some styles and practices
          of scams that we are not aware of. Scammers can be pretty creative! And because of these kinds of buyers,
          sellers who fall victim to the scammers' antics get disheartened and heavily affected. Not only does it affect
          the seller's earnings, but it also jeopardizes the seller's account.
        </p>
        <p>
          Thankfully, on Poshmark, not only do they have Posh Protect for buyers, but they also offer protection to
          their sellers, which gives a sense of guarantee and security to retailers. Before we dive right in on how you
          can take advantage of Poshmark's seller protection, it is also essential that you know how your buyers are
          protected.
        </p>

        <h3>Posh Protect</h3>
        <p>
          On Poshmark, posters are made secure by Posh Protect, which aims to provide buyers protection to make them
          feel comfortable using the platform for their online shopping. The policies on this buyer's protection cover a
          refund system that states that a full refund will be given to the buyer if the item was never shipped or the
          item received did not match the seller's listing description. All other rules are as follows:
        </p>
        <ol>
          <li>
            Payment for an order will not be released to the seller unless the buyer has confirmed that they received
            the item as described.
          </li>
          <li>
            Buyers are given three days after delivery to report if the ordered item has any problem, which requires
            photos that should support reports or claims. Should the buyer fail to report any dispute within the given
            period, the platform will release the payment to the seller, and the sale is considered final.
          </li>
          <li>
            If the buyer's claim is verified, Poshmark will send a return label to the buyer to return the order to the
            seller, which they should accomplish within five days after the claim's acceptance. After doing so, the
            refund is going to be processed.
          </li>
        </ol>

        <p>Buyers are only eligible for a refund if the claim falls under the following:</p>
        <ul>
          <li>Items with undisclosed damage</li>
          <li>Received an incorrect or missing item</li>
          <li>The item is different from the description</li>
          <li>The item received is a counterfeit or is not authentic</li>
        </ul>
        <p>
          Note that filing refunds due to change of mind or items that do not fit your style and transactions completed
          outside the Poshmark platform are not covered by Posh Protect.
        </p>

        <h3>Poshmark Seller's Protection</h3>
        <p>
          Before selling on Poshmark, we are sure that you have asked yourself the question: Is Poshmark legit? And now
          that you have experienced earning through this platform, your questions have been answered. Yes! Poshmark is a
          legit marketplace, and it has a community of sellers and buyers that co-exist, giving opportunities to each
          other.
        </p>
        <p>
          If you wonder if sellers like you get provided with protection when selling on Poshmark, the answer is yes.
          Poshmark not only takes care of its buyers but its sellers as well. The rule is simple: transact within the
          marketplace and abide by all the rules Poshmark has put in place to make sure that you have a smooth selling
          experience. Here are the things that you should pay attention to:
        </p>
        <ul>
          <li>
            <strong>Shipping:</strong> Make sure to always use the USPS Priority Mail shipping label Poshmark sends you
            where you should put it on your package. This ensures that your package is scanned through the USPS tracking
            system, which will entitle you to be fully covered by Poshmark should the package get lost in transit by
            USPS.
          </li>
          <li>
            <strong>Notifications:</strong> When your package gets scanned into the USPS system, Poshmark will send you
            and your buyer an email notification containing the package's tracking information. This gives you the
            chance to check and track your item's shipment status anytime during the period that it's on its way to the
            buyer. A notification is also sent to the buyer when USPS indicates that the package has been successfully
            delivered. Poshmark sends a notification to the buyer so they can review and accept their order in the app.
          </li>
          <li>
            <strong>Delivery:</strong> For any item that costs $400 and up, Poshmark requires a signature from the
            recipient upon delivery. This additional feature secures your item from getting lost upon delivery. It also
            helps you stop potentially opportunistic buyers who may claim that they hadn't received their order yet when
            they already did.
          </li>
          <li>
            <strong>Release of Payment:</strong> Poshmark will credit your earnings to your account after the seller has
            marked their order as accepted. You may redeem your earnings through direct deposit, or you may also request
            a check. All payments on orders that the buyer does not acknowledge after three days upon receipt will also
            be automatically credited to your account.
          </li>
        </ul>

        <h3>Keep Calm and Know What To Do</h3>
        <p>
          Now that you know how you, as a seller, get protected by Poshmark's policies, it is important that you also
          know what to do when your buyers report disputes and problems about your item.
        </p>
        <p>
          <strong>Confidence in your item.</strong> If you are an honest seller, there is little to no chance of getting
          a buyer complaint. But as the saying goes, you can't please everybody. This somehow applies to the online
          shopping community. Like each individual has a unique personality, buyers are the same, too. So don't fret
          easily and question yourself what wrong you have done when a buyer reports a problem about you. If you know
          your items, you don't have to worry about anything.
        </p>
        <p>
          <strong>Do not lose hope.</strong> While this is easier said than done, in reality, many sellers often get
          deterred when they receive a complaint against their items. But it is essential to keep your cool and remember
          that not all complaints about your items are on a losing end, so don't lose hope just yet. The key to success
          in countering any reports on you is keeping evidence or proof and knowing that you are selling an honest item.
        </p>
        <p>
          <strong>There is a due process.</strong> If a buyer reports against your item, Poshmark investigates before
          arriving at a decision. Buyers are asked to provide details and photos of the item before the Poshmark team
          decides on a resolution. Hence, you have a higher chance of winning the case if you have all the necessary
          evidence to prove that your item is not what the buyer claims to be.
        </p>

        <h3>Different Types of Scams</h3>
        <p>
          As mentioned earlier, the Poshmark community comprises social individuals who help each other. Whether you're
          a seller or a buyer, one way or another, you have helped a co-posher in boosting their listings by doing some
          boosting features such as sharing, following, liking, leaving love notes, and returning shares and follows.
          However, amidst all the nice people on the platform, some intend to take advantage of the sellers. They are
          the ones that result in scamming Poshmark sellers by buying an item and then intentionally filing a report or
          a case against it.
        </p>
        <p>
          These people can become creative and come up with ways to fraudulently provide evidence and reasons for
          getting a refund. This is why you must be aware of the scams that scammers often do to save yourself from a
          stressful situation and your Poshmark closet for a possible loss of item and income. Here are some buyers'
          approaches to how they would want to take advantage of you:
        </p>
        <ul>
          <li>
            <strong>Orders a new item, then returns it as not as described.</strong> A buyer will purchase a brand new
            or in a very good condition item and then use the item before the 3-day after delivery period is up. Given
            that they still have time left to file a report if the ordered item has any problem, they will now file a
            case on Poshmark about receiving an item that's not what they are expecting so they can get a refund.
            Unfortunately, this kind of claim can get as bad as buyers resort to intentionally damaging the items to
            succeed in their dispute. People like these want to experience and use the items without paying any fees. A
            new fashion piece to flaunt for free!
            <p>
              What you can do: It is safe to check the buyer's profile first to avoid this kind of scam. Check if they
              have any positive feedback or love notes given. You can also take a picture or even a video of your item
              before you ship them, including the time when you are packing it. This way, you can justify your item's
              condition before the buyer receives it, and Poshmark can have a good basis during their investigation. You
              should also keep any screenshots of your conversation with the buyer containing your exchange of messages
              about the item's condition (if the item has flaws). Lastly, you may contact Poshmark customer service and
              provide all the necessary proof to counter any allegations.
            </p>
          </li>
          <li>
            <strong>Buys a high-value item, then swaps it with a different one.</strong> The buyer will purchase a
            high-value item and file a claim stating that they received a counterfeit or fake item. This usually occurs
            in luxury brands where fake versions are easily acquired in the market. A buyer who would want to scam you
            will exchange your legit item (i.e., a Chanel or Louis Vuitton bag) with a fake bag and claim that you are
            scamming them. Sneaky buyers may also intentionally ruin the item to exaggerate their claim.
            <p>
              What you can do: Be as detailed as you can when taking photos of these items. Include each angle of the
              item, the texture, color, serial number, proof of purchase (if available), visible damage, and tag that
              will help its authentication. Furthermore, make sure to check the buyer's profile for good feedback and
              how long they have been a member of Poshmark. One golden rule to consider when selling online is only
              selling what you can afford to lose. You can never tell when a sneaky scammer can find a way to win their
              dispute.
            </p>
          </li>
          <li>
            <strong>Asks to take the transaction outside Poshmark.</strong> The buyer will leave a comment or respond to
            your discount offer asking to move the transaction outside Poshmark for some reason. They may ask that you
            discuss the sale on social media apps like Facebook messenger or Instagram and complete the transaction
            there. If you agree to their terms, you can be scammed in many ways. Also, this will lose you the Poshmark
            seller protection as the items will then be shipped outside the platform.
            <p>
              What you can do: Trust your instinct and investigate the buyer's profile. If it looks new or without any
              good feedback, it is safe to avoid dealing with this buyer. It would be best to be firm in doing your
              transactions inside Poshmark. Additionally, it would not make sense to have a customer who doesn't want to
              be protected under Posh Protect. Be wise. Stay vigilant!
            </p>
          </li>
        </ul>

        <h3>Stay Under Poshmark's Seller Protection</h3>
        <p>
          Scammers are everywhere, and there might be tons of other modus operandi that they can use to get their hands
          on your items and take advantage of sellers like you. Hence, if you want to stay protected under Poshmark
          Seller Protection, keep in mind to always practice and abide by the platform rules and regulations.
        </p>
        <p>
          Often, sellers get excited about signing up on a marketplace without going through the community guidelines,
          which is not good. Remember that reading through the guidelines makes you aware of the things that you should
          follow and will also ensure your security and give you an advantage over disputes and claims against you.
        </p>
        <p>As a seller, always remember that you have to:</p>
        <ul>
          <li>
            <strong>Be a trustworthy seller.</strong> When listing an item, you have to remain truthful and list only
            all the facts about your item. It includes being as detailed as you can on the item's condition,
            description, flaws, size, and photos. Ensure that you always set your buyers' expectations to make them
            aware of what they are buying, which will greatly help you avoid any unforeseen reports.
          </li>
          <li>
            <strong>Only use the shipping label provided by Poshmark.</strong> Never transact outside Poshmark and use
            another courier to send your item to your buyer. Remember, any transaction done outside the platform is not
            covered by any protection. In addition to this, to maintain a good reputation as a seller, it is ideal that
            you ship any orders immediately or within five days upon receipt of Poshamark's priority mail shipping
            label.
          </li>
          <li>
            <strong>Communicate well with your buyer.</strong> Communication is the key to any successful and
            unproblematic transactions. Make sure that you and the buyer share the same page before, during, and after
            the sale is done. You must answer all your buyer's questions before you complete any transaction. Building a
            good reputation and communicating well with your buyer can earn you loyal customers.
          </li>
          <li>
            <strong>Only use your own photos.</strong> To set proper expectations with your buyer, you must provide the
            actual photos of your items. While stock photos can look good, you may be at risk of having issues with its
            proprietary rights that may violate any laws. Furthermore, using your photos will ensure that you clearly
            indicate the state and condition of the item.
          </li>
        </ul>

        <h3>Automate with OneShop</h3>
        <p>
          Online selling is indeed a profitable venture. Part of becoming successful in this field is knowing how to
          protect yourself as a seller from scams and disputes that you may encounter. Dealing with such things can take
          up a lot of your time, so you will need a reliable assistant who can ensure your closet is active while you
          deal with buyers and resolve any issues.{' '}
        </p>
        <p>
          OneShop is a dependable app for automating your Poshmark activities while maintaining a human-like behavior
          that protects your account from being flagged and getting into Share jail. It also helps you send offers to
          likers, like, follow, unfollow, cross-list, and relist to ensure that your Poshmark listings stay on top of
          the feed where many potential buyers can see them.{' '}
        </p>
        <p>
          Managing your Posh account with a service like OneShop at hand makes things easy. You don't have to spend long
          hours in front of your computer anymore trying to manage everything simultaneously as OneShop can assist you
          with other business-related tasks. This includes ordering shipping supplies, scheduling USPS pickup, looking
          up an item's registered ID to see the item's brand, and cross-posting to other marketplaces like Mercari,
          Depop, Tradesy, and eBay. In addition, this intelligently made automation service can delist your listings
          automatically once they are sold on other platforms to protect you from selling a single item to multiple
          buyers.
        </p>
        <p>
          <a href='https://tools.oneshop.com/signup'>Sign-up to OneShop</a> and take advantage of its 7-day free trial
          with no outright payment. Let this excellent automation service help you have more time in your hands to focus
          on other things essential to growing your business.{' '}
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
